import { render, staticRenderFns } from "./InfoDetails.vue?vue&type=template&id=b2c173a6&scoped=true"
var script = {}
import style0 from "./InfoDetails.vue?vue&type=style&index=0&id=b2c173a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c173a6",
  null
  
)

export default component.exports